module.exports = __webpack_public_path__ + "media/images/icon-nav-setting-9eb12068625c67799dd84d33492231ac.png";